var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m18.5 8.505-.34.367a.5.5 0 0 0 .68-.734zm-6-4.866 4.489 4.15.914.845.198.183.045.042.011.01.003.003.34-.367.34-.367h-.002l-.002-.003-.011-.01-.046-.042-.197-.183-.914-.845-4.647-4.296a1.503 1.503 0 0 0-2.04-.002l-5.82 5.381a.5.5 0 0 0 .678.734L11.5 3.64v17.386a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgArrowUp = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC41IDguNTA1MTlMMTguMTYwNiA4Ljg3MjM0QzE4LjM2MzQgOS4wNTk3OSAxOC42Nzk3IDkuMDQ3MzcgMTguODY3MiA4Ljg0NDZDMTkuMDU0NiA4LjY0MTgzIDE5LjA0MjIgOC4zMjU0OSAxOC44Mzk0IDguMTM4MDRMMTguNSA4LjUwNTE5Wk0xMi41IDMuNjM5NDJMMTYuOTg4OSA3Ljc4OTE0TDE3LjkwMyA4LjYzNDIzTDE4LjEwMDYgOC44MTY5TDE4LjE0NjIgOC44NTg5OUwxOC4xNTcxIDguODY5MDZMMTguMTU5NyA4Ljg3MTUzTDE4LjE2MDQgOC44NzIxNEwxOC4xNjA1IDguODcyMjlMMTguMTYwNiA4Ljg3MjMyTDE4LjUgOC41MDUxOUwxOC44Mzk0IDguMTM4MDJMMTguODM5NCA4LjEzNzk5TDE4LjgzOTIgOC4xMzc4M0wxOC44Mzg1IDguMTM3MjNMMTguODM1OSA4LjEzNDc2TDE4LjgyNSA4LjEyNDY5TDE4Ljc3OTQgOC4wODI1OUwxOC41ODE4IDcuODk5OTNMMTcuNjY3NyA3LjA1NDg0TDEzLjAyMSAyLjc1OTE5QzEyLjQ0NzkgMi4yMjkzOSAxMS41NTgzIDIuMjIzNjcgMTAuOTgxOCAyLjc1NjY2TDUuMTYwNTkgOC4xMzgwNEM0Ljk1NzgyIDguMzI1NDkgNC45NDU0IDguNjQxODMgNS4xMzI4NSA4Ljg0NDZDNS4zMjAzIDkuMDQ3MzcgNS42MzY2NCA5LjA1OTc5IDUuODM5NDEgOC44NzIzNEwxMS41IDMuNjM5NDJMMTEuNSAyMS4wMjQ1QzExLjUgMjEuMzAwNiAxMS43MjM5IDIxLjUyNDUgMTIgMjEuNTI0NUMxMi4yNzYxIDIxLjUyNDUgMTIuNSAyMS4zMDA2IDEyLjUgMjEuMDI0NUwxMi41IDMuNjM5NDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";